import React, { createContext, useState, useContext, useEffect } from 'react';

// Créer le contexte de langue
const LanguageContext = createContext();

// Langues disponibles
export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' }
];

// Fournisseur du contexte de langue
export const LanguageProvider = ({ children }) => {
  // Obtenir la langue du navigateur ou utiliser l'anglais par défaut
  const getBrowserLanguage = () => {
    const browserLang = navigator.language.split('-')[0];
    const isSupported = languages.some(lang => lang.code === browserLang);
    return isSupported ? browserLang : 'en';
  };

  // État de la langue actuelle
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || getBrowserLanguage();
  });

  // Mettre à jour la langue
  const changeLanguage = (code) => {
    setLanguage(code);
    localStorage.setItem('language', code);
  };

  // Mettre à jour le document lang attribute
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte de langue
export const useLanguage = () => useContext(LanguageContext);
